// extracted by mini-css-extract-plugin
export default {"items":"BurgerItem_items__8A707"};